import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Observable, timer } from 'rxjs';

import * as _moment from 'moment';
import { map } from 'rxjs/operators';
const moment = _moment;

@Component({
  selector: 'fgb-time-since',
  templateUrl: './time-since.component.html',
  styleUrls: ['./time-since.component.scss'],
})
export class TimeSinceComponent implements OnInit, OnChanges {
  @Input() startDate: Date;
  timer$: Observable<string>;
  constructor() {}

  ngOnChanges() {
    if (this.startDate) {
      this.timer$ = timer(0, 1000).pipe(map(() => this.formatTime()));
    }
  }

  ngOnInit() {}

  private formatTime(): string {
    if (!this.startDate) {
      return '';
    }

    let duration = moment.duration(moment.utc().diff(moment.utc(this.startDate)));

    const days = Math.floor(duration.asDays());

    const hours = Math.floor(duration.asHours());

    const minutes = Math.floor(duration.asMinutes());

    if (days) {
      if (days > 1) {
        return `${days} days ago`;
      }
      return '1 day ago';
    } else if (hours) {
      if (hours > 1) {
        return `${hours} hours ago`;
      }
      return `1 hour ago`;
    } else if (minutes) {
      if (minutes > 1) {
        return `${minutes} mins ago`;
      }
      return `1 min ago`;
    } else {
      return `Just now`;
    }
  }
}
